import * as React from "react"
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import InfoModal from "../Components/modals/InfoModal";
import { Box, Button } from "@mui/material";
import { LoadingBackdropIndeterminate } from "../Components/LoadingBackdrop";
import { AXIOS_API_INSTANCE } from "../Constants";
import { send_authorized_request } from "../Constants/cognito";
import { useSnackbar } from "notistack";
import InputModal from "../Components/modals/InputModal";

export default function AIButton({
    children,
    make_prompt,
    prompt_history = [],
    use_markdown = true,
    use_pre = false,
    callback = null
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState(false)
    const [infoModal, setInfoModal] = React.useState({ open: false, title: '', content: '' })
    const [inputModal, setInputModal] = React.useState({
        open: false,
        callback: null,
        label: 'Request',
        title: 'Ask AI',
        defaultInput: ''
    })

    const prompt = () => {
        if (prompt_history && prompt_history.length > 0) {
            setInputModal({
                ...inputModal,
                open: true,
                callback: (results, prompt) => {
                    if (results) {
                        askAI(prompt, prompt_history)
                    }
                    setInputModal({ ...inputModal, open: false })
                }
            })
        }
        else if (make_prompt) {
            const { prompt, history } = make_prompt();
            const actual_history = (prompt_history ?? []).concat(history ?? [])
            askAI(prompt, actual_history)
        }
    }

    const askAI = (prompt, history) => {
        setLoading(true)

        send_authorized_request(() => AXIOS_API_INSTANCE.post(`ai/ask`, { prompt: prompt, history: history, use_markdown: use_markdown }).then((response) => {
            setLoading(false)
            if (callback) {
                callback(response.data.data)
            } else {
                const newData = {
                    title: "AI Response",
                    content: response.data.data.output.content[0].text,
                    maxWidth: "md",
                    level: "ai",
                    markdown: use_markdown
                }
                if (use_pre) {
                    newData.content = (<pre style={{ whiteSpace: 'pre-wrap' }}>{response.data.data.output.content[0].text}</pre>)
                }
                setInfoModal({
                    open: true,
                    ...newData,
                    callback: () => { setInfoModal({ open: false, ...newData }) },
                })
            }
        }).catch((error) => {
            setLoading(false)
            console.log(error);
            setError(true)
            enqueueSnackbar(`Failed to ask AI: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
        }))
    }


    return (
        <React.Fragment>
            <LoadingBackdropIndeterminate
                open={loading}
                text="Asking AI"
            />
            <Button variant="contained" onClick={prompt} disabled={error}>
                <Box sx={{ display: 'flex' }}>
                    <AutoAwesomeIcon /><Box sx={{ pl: 1 }}>{children}</Box>
                </Box>
            </Button>
            <InfoModal
                {...infoModal}
            />
            <InputModal
                {...inputModal}
            />
        </React.Fragment>
    )
}